/**
 * 金額・税・手数料の共通ロジック（全アプリ＋DBと一致させる）。
 *
 * 2026-07-12 中島社長決定：金額表示は税込（消費税10%）に統一。
 *  - 業者が入力する見積り金額 = 税抜（工事費の本体）。cases.awarded_amount / bids.amount に保存。
 *  - 顧客支払額（税込）= 税抜 × 1.1（総額表示）。
 *  - プラットフォーム手数料 = 税抜 × 20%（calcFee）。
 *  - 業者手取り（受取見込・振込額）= 税込 − 手数料。
 * DB: calc_sitame_fee(税抜)=fee、payments.amount=税込、vendor_payout=税込−fee（sql/28）。
 */

/** 消費税率（10%） */
export const TAX_RATE = 0.10;
/** プラットフォーム手数料率（一律20%・上限なし） */
export const FEE_RATE = 0.20;

/** 税抜 → 税込（総額）。丸めは四捨五入でDBの round() と一致。 */
export function withTax(base: number): number {
  if (!Number.isFinite(base) || base <= 0) return 0;
  return Math.round(base * (1 + TAX_RATE));
}

/** 消費税額（税込 − 税抜）。 */
export function taxAmount(base: number): number {
  if (!Number.isFinite(base) || base <= 0) return 0;
  return withTax(base) - Math.round(base);
}

/** プラットフォーム手数料（税抜 × 20%）。 */
export function calcFee(base: number): number {
  if (!Number.isFinite(base) || base <= 0) return 0;
  return Math.round(base * FEE_RATE);
}

/** 業者の受取見込額（税込 − 手数料）。 */
export function calcPayout(base: number): number {
  if (!Number.isFinite(base) || base <= 0) return 0;
  return withTax(base) - calcFee(base);
}

/** 円表記（¥1,234）。 */
export function yen(n: number): string {
  return `¥${Math.round(n || 0).toLocaleString("ja-JP")}`;
}
